import React from 'react';
import { pricingPlans } from '../data/mockData';
import { Button } from './ui/button';
import { Check } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
const PricingCard = ({ plan, onOpenContactForm, delay }) => {
  const card = useScrollAnimation({ threshold: 0.1 });
  const isRec = plan.recommended;
  return (
    <div ref={card.ref} data-testid={`pricing-card-${plan.id}`}
      className={`group flex flex-col rounded-2xl transition-all duration-300 scroll-fade-up scroll-delay-${delay} ${card.isVisible?'scroll-visible':''} ${isRec?'bg-[#1E1B4B] text-white border-2 border-[#6366F1]/40 relative lg:-mt-4 lg:mb-4 shadow-[0_8px_32px_rgba(99,102,241,0.15)]':'bg-white border border-[#E2E2F0] hover-soft'}`}>
      {isRec && <span className="absolute -top-3 left-6 bg-[#A78BFA] text-[#1E1B4B] text-[9px] font-bold uppercase tracking-wider px-3 py-1 rounded-full">Recommended</span>}
      <div className="p-7 flex-1 flex flex-col">
        <div className="mb-6">
          <h3 className={`text-lg font-semibold mb-0.5 tracking-tight ${isRec?'text-white':'text-[#1E1B4B]'}`} style={{fontFamily:"'Playfair Display',serif",fontSize:'1.15rem'}}>{plan.name}</h3>
          <p className={`text-xs mb-3 ${isRec?'text-white/60':'text-[#6B7280]'}`}>{plan.tagline}</p>
          <span className={`text-4xl font-semibold tracking-tighter ${isRec?'text-[#A78BFA]':'text-[#1E1B4B]'}`} style={{fontFamily:"'Playfair Display',serif"}}>{plan.price}</span>
          <p className={`text-xs mt-1 ${isRec?'text-white/50':'text-[#6B7280]'}`}>{plan.federal}</p>
        </div>
        <ul className="space-y-2.5 flex-1 mb-6">
          {plan.features.map((f,i)=>(
            <li key={i} className="flex items-start gap-2.5">
              <Check className={`w-3.5 h-3.5 mt-0.5 flex-shrink-0 ${isRec?'text-[#A78BFA]':'text-[#6366F1]'}`} strokeWidth={2} />
              <span className={`text-sm ${isRec?'text-white/80':'text-[#4B5563]'}`}>{f}</span>
            </li>
          ))}
        </ul>
        <div className="mt-auto">
          <p className={`text-[10px] text-center mb-2.5 ${isRec?'text-white/50':'text-[#6B7280]'}`}>{plan.note}</p>
          <Button data-testid={`pricing-cta-${plan.id}`} onClick={onOpenContactForm} className={`w-full font-semibold h-10 rounded-xl ${isRec?'bg-[#A78BFA] text-[#1E1B4B] hover:bg-[#C4B5FD]':'btn-gradient text-white'}`}>{plan.buttonText}</Button>
        </div>
      </div>
    </div>
  );
};
const PricingSection = ({ onOpenContactForm }) => {
  const header = useScrollAnimation({ threshold: 0.2 });
  return (
    <section id="pricing" data-testid="pricing-section" className="py-16 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-16 scroll-fade-up ${header.isVisible?'scroll-visible':''}`}>
          <span className="text-xs tracking-[0.2em] uppercase text-[#6366F1] mb-3 block font-semibold">Fee Schedule</span>
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#1E1B4B] mb-4" style={{fontFamily:"'Playfair Display',serif"}}>Transparent, Fixed-Fee Pricing.</h2>
          <p className="text-base font-normal text-[#4B5563] leading-relaxed">No hidden costs. No hourly billing. Every plan includes expert review and direct USPTO filing.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 items-start">
          {pricingPlans.map((p,i)=><PricingCard key={p.id} plan={p} onOpenContactForm={onOpenContactForm} delay={i+1} />)}
        </div>
      </div>
    </section>
  );
};
export default PricingSection;
